import React, { useState, useCallback } from 'react';
import { Dialog, Box, Typography, Tabs, Tab, Button } from '@mui/material';
import { IAccount } from 'common/accounts.interface';
import PixByKey from './components/PixByKey';
import PixByFavorecido from './components/PixByFavorecido';
import PixByBankData from './components/PixByBankData';

type TProps = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  account?: IAccount;
};

const PixTransferModal = ({ open, onClose, onSuccess, account }: TProps) => {
  const [tab, setTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSuccess = useCallback(() => {
    setSuccess(true);
    onSuccess();
  }, []);

  const handleClose = () => {
    setSuccess(false);
    setTab(0);
    onClose();
  };
  const handleDialogClose: React.ComponentProps<typeof Dialog>['onClose'] = (event, reason) => {
    if (isLoading && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return;
    }
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown={isLoading}
      fullWidth
      PaperProps={{ sx: { borderRadius: '16px' } }}
    >
      <Box p={4}>
        {success ? (
          <>
            <Typography variant="h5" fontWeight={600} align="center" mb={2}>
              Solicitação recebida!
            </Typography>
            <Typography align="center" color="text.secondary" mb={4}>
              Estamos aguardando a aprovação do pagamento.
            </Typography>
            <Button fullWidth variant="contained" onClick={handleClose}>
              Ok, aguardar
            </Button>
          </>
        ) : (
          <>
            <Typography variant="h5" fontWeight={600} align="center" mb={4}>
              Pagamento via PIX
            </Typography>

            <Tabs
              value={tab}
              onChange={(_, v) => setTab(v)}
              variant="fullWidth"
              TabIndicatorProps={{ style: { display: 'none' } }}
              sx={{
                mb: 4,
                backgroundColor: (theme) => theme.palette.primary.light,
                borderRadius: 2,
                p: 0.5,
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontWeight: 500,
                  borderRadius: 1.5,
                  minHeight: 44,
                  color: (theme) => theme.palette.primary.contrastText,
                },
                '& .Mui-selected': {
                  backgroundColor: 'primary.contrastText',
                  color: (theme) => theme.palette.primary.main,
                },
              }}
            >
              <Tab label="Chave PIX" disabled={isLoading} />
              <Tab label="Selecionar favorecido" disabled={isLoading} />
              <Tab label="Dados bancários" disabled={isLoading} />
            </Tabs>

            {tab === 0 && (
              <PixByKey onSuccess={handleSuccess} onCancel={handleClose} onSubmitting={setIsLoading} accountNumber={account?.bankAccount} />
            )}
            {tab === 1 && <PixByFavorecido onSuccess={handleSuccess} onCancel={handleClose} onSubmitting={setIsLoading} />}
            {tab === 2 && <PixByBankData onSuccess={handleSuccess} onCancel={handleClose} onSubmitting={setIsLoading} />}
          </>
        )}
      </Box>
    </Dialog>
  );
};

export default PixTransferModal;
